/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import cn from 'classnames';
import { connect } from 'react-redux';
import { colourThemeType } from '../../../propTypes';
import theme from '../../../styles/theme';
import { getSliceContent } from '../../../selectors';
import CompetitionForm from '../CompetitionForm';
import SuccessMessage from '../SuccessMessage';
import FadeInOut from '../FadeInOut';

const Competition = ({
  success, classes, title, description, sliceId, onSubmit, successSubTitle, successTitle,
  successButtonText, successButtonLink, terms, error, colourTheme,
}) => (
  <div className={cn(classes.form, classes.flexChild)}>
    <FadeInOut visible={!success}>
      <div className={classes.indent}>
        <header>
          {title.text && <div dangerouslySetInnerHTML={{ __html: title.html }} />}
          {description.text && <div dangerouslySetInnerHTML={{ __html: description.html }} />}
        </header>
      </div>
      <CompetitionForm
        sliceId={sliceId}
        onSubmit={onSubmit}
        colourTheme={colourTheme}
      />
      {error && (
        <small className={classes.error}>
          Sorry, something has gone wrong. Please try again.
        </small>
      )}
      <small className={classes.tc}>
        {terms}
      </small>
    </FadeInOut>
    <FadeInOut visible={success} absolute>
      <SuccessMessage
        title={successTitle}
        subtitle={successSubTitle}
        buttonText={successButtonText}
        buttonLink={successButtonLink}
        colourTheme={colourTheme}
      />
    </FadeInOut>
  </div>
);

Competition.defaultProps = {
  successButtonText: '',
  successButtonLink: '',
  title: {
    text: '',
    html: '',
  },
  description: {
    text: '',
    html: '',
  },
};

Competition.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  sliceId: PropTypes.number.isRequired,
  success: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.shape({
    text: PropTypes.string,
    html: PropTypes.string,
  }),
  description: PropTypes.shape({
    text: PropTypes.string,
    html: PropTypes.string,
  }),
  successTitle: PropTypes.string.isRequired,
  successSubTitle: PropTypes.string.isRequired,
  successButtonText: PropTypes.string,
  successButtonLink: PropTypes.string,
  terms: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  colourTheme: colourThemeType.isRequired,
};

const mapStateToProps = (state, { sliceId }) => ({
  title: getSliceContent(state, sliceId).title,
  description: getSliceContent(state, sliceId).description,
  successTitle: getSliceContent(state, sliceId).success_title,
  successSubTitle: getSliceContent(state, sliceId).success_subtitle,
  successButtonText: getSliceContent(state, sliceId).success_button_text,
  successButtonLink: getSliceContent(state, sliceId).success_button_anchor,
  terms: getSliceContent(state, sliceId).terms_and_conditions,
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    flexChild: {
      flex: 1,
      flexBasis: '50%',
      position: 'relative',
    },
    form: {
      background: ({ colourTheme }) => colourTheme.backgroundColour,
      padding: '12px',
      [theme.breakpoints.up('md')]: {
        padding: '60px',
      },
      [theme.breakpoints.up('lg')]: {
        padding: '60px',
      },
      [theme.breakpoints.up('xl')]: {
        padding: '80px',
      },
      '& header h1': {
        fontSize: 28,
      },
      '& header p': {
        fontSize: 16,
        fontFamily: theme.typography.primaryFontFamily,
      },
      '& header ul': {
        listStyleType: 'disc',
      },
      '& header img': {
        marginBottom: theme.spacing.vertical.xxs,
      },
    },
    indent: {
      paddingLeft: '8px',
    },
    tc: {
      textAlign: 'center',
      display: 'block',
    },
    error: {
      background: theme.colors.brandError,
      color: theme.colors.white,
      textAlign: 'center',
      fontSize: 12,
      maxHeight: '17px',
      display: 'block',
      marginBottom: 8,
    },
  }),
)(Competition);
